import { getUser } from "src/api/Admin"

export interface AdAccountType {
    uid : number,
    user_id: string,
    user_name: string,
    army_number: string,
    email: string,
    phone: number,
    user_type: string,
    deleted_at: Date | null,
    is_active: boolean,
    admin_approval: boolean
}

export const LoadAccount = async (status:string, page:number,pageSize:number)=>{
    const response = await getUser(status, page, pageSize)
    
    return {
        totalCount:response.total,
        approved:response.approved,
        pending:response.pending,
        inactive:response.inactive,
        totalPage:response.total_pages,
        data:response.data as AdAccountType[]
    }
}